import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AgmCoreModule, MapsAPILoader, AgmMap} from "@agm/core";
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { GlobalConstants } from '../global-constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../services/auth.service';


declare var google: any;
declare var $: any;


@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.less']
})


export class BookingComponent implements OnInit, OnDestroy {
  minDate: Date;
  pickupDate: Date | null = null;
  pickupTime: string = '';
  hasReturnTrip: boolean = false;
  returnPickupDate: any = '';
  returnPickupTime: string = '';
  minTime: any;
  mode:String;
  vehicletype: String;
  datetime:boolean;
  isoutstation:boolean;
  totalMiles:any;
  charge:any;
  waitingcharge:any;
  roundTripwaitingcharge:any;
  roundtripWaitings: 0;
  totalPrice:any;
  rate:any;
  totalWaititng:any;
  chargeRound:any;
  waitingchargeRound:any;
  waitingdayscharge=0;
  rwaiting=0;
  waitingforMint=0.333333;
  stopslist:any;
  addstops: any;
  ttype:any;
  btype:any;
  hide = true;
  otpShow:Boolean;
  drivers:[];
  slctli:any;
  checkrun=0;
  checked = false;
  checked2 = false;
  checkfavdrvr =false;
  tipAmount: 0;
  promocode: string = '';
  promocodeApplied: any;
  promocodeID: any;
  promocodeAmount: any;
  isButtonClicked = false;
  SpecialDayMessage: string = '';
  wallet: any;
  walletUsageAmount: number = 0;
  validatedwalletUsageAmount: number = 0;
  walletOtp: string = '';
  walletOtpVerified: boolean = false;
  otpRequested: boolean = false;
  trailerTowing: boolean = false;
  trailerCost: number = 0;
  baseCharge: number = 15;
  noOfDays: number = 1;
  fareMessage: string = '';
  private changeDetectionIntervalId: any;

  constructor(private route:Router,private http: HttpClient,private ref: ChangeDetectorRef, public datepipe: DatePipe, private authService: AuthService) {
    ref.detach();
    this.changeDetectionIntervalId = setInterval(() => this.ref.detectChanges(), 100);
   }

  ngOnDestroy(): void {
    clearInterval(this.changeDetectionIntervalId);
  }
   public addresses: any[] = [
    {
      id: 1,
      address: '',
    },
  ];
  ngOnInit(): void {
    // Booking page requires the trip details picked on the home page. If someone lands
    // here directly (e.g. browser back/forward, or a bookmark) without that state, bail
    // out before touching it — the code below assumes booking_step1 is present.
    if (localStorage.getItem("booking_step1") === null) {
      this.route.navigate(['/']);
      return;
    }

    this.minDate = new Date();
    // this.vehicletype="";
    this.datetime=true;
    this.isoutstation=true;
    this.totalMiles=localStorage.getItem("totaldistance");
    this.totalPrice=localStorage.getItem("totalprice");
    this.waitingchargeRound=localStorage.getItem("waitingchargeround");
    this.chargeRound=localStorage.getItem("chargeround");
    this.totalWaititng=0;
    this.rate=2.50;
    this.promocodeAmount=0;
    let step0:any;
    this.addstops=0;
    this.otpShow=false;
    $("#step2error").hide();
    $(".booknow").hide();
    $("#error5").hide();
    $("#otp").hide();
    $(".driverprefer").hide();
    this.editbSummary();
    this.bookingsummary();
    this.checkchanged();
    let step1 = JSON.parse(localStorage.getItem("booking_step1") || '{}');
    console.log('step1');
    console.log(step1);
    this.fetchCustomerDetails();
    if (this.authService.isLoggedIn()) {
      $(".notregistered").hide();
      $(".registeresproceed").show();
    } 
    else{
      $(".registeresproceed").hide();
      $(".notregistered").show(); 
    }
    if(step1.data[0].booking_type != "schedule"){
      $("#scheduled").hide();
      this.datetime=false;
    }
    if(step1.data[0].trip_type != "outstation"){
      $("#outstation-field").hide();
      this.isoutstation=false;
    }
    step0 = JSON.parse(localStorage.getItem("booking_step1") || '{}');
    let stopsall = step0.data[0].stops;
    var stops = [];
    for (let i = 0; i < stopsall.length; i++) {
      this.totalWaititng=this.totalWaititng+parseInt(stopsall[i].stop_waiting);
  }
    this.calculate();
    $("#updatebtn").hide();
    setTimeout(() => $("#trigcalc").remove(),2500);
    
  }
  // public startdatechanged(date:any){
  //  if(this.datepipe.transform(date, 'MM/dd/yyyy')==this.datepipe.transform(this.minDate, 'MM/dd/yyyy')){
  

  //      this.minTime = this.minDate.getTime() + (2*60*60*1000);
  //      $('.timepkr').val('');
  //   }
  //   else{
  //      this.minTime ="";

  //   }
  // } 
  get triggerCalculate(){
    this.calculate();
    this.checkrun=this.checkrun+1;
    return 'calculating';
  }
  addAddress() {
    this.addresses.push({
      id: this.addresses.length + 1,
      address: '',
    });
    // alert( (<HTMLInputElement>document.getElementById("mat-input-9")).value);
  }

  

  removeAddress(i: number) {
    this.addresses.splice(i, 1);
  }

  checkPromocode() {
    const headers = { 'Content-type': 'application/json'};
    const body = {
      promocode:this.promocode,
    };
    this.http.post(GlobalConstants.apiURL+'promocode_check', body, { headers })
      .subscribe((Response: any) => {
        if (Response) {
          if (Response.status === "success") {
            this.promocodeID = Response.data.id;
            this.promocodeApplied = Response.data.code;
            // actual discount amount comes back from /apis/calculatefare
            this.calculate();
          } else {
            Swal.fire('Sorry', Response.message, 'error');
          }
        }
      });
  }
  public generateOtp(mobile:any){
    this.authService.sendOtp(mobile).subscribe();
  }
  public login(phone:any,password:any){
    if(!phone || !password){
      $(".errormod").html(" All fields are required");
      $(".errormod").show();
    }
    else{
      $(".errormod").hide();

      this.authService.login(phone, password).subscribe((Response) => {
        if (Response.status === "success") {
          this.authService.setSession(Response.customer_id, Response.customer_name, Response.token);
          this.ngOnInit();
          if(this.slctli.length>0){
            $(".driverprefer").show();
          }
        }
        else{
          $(".errormod").html("Please check phone and password");
          $(".errormod").show();
        }
      });
    }
  }

public register(name:any, mobile:any, email:any, password:any, otpnew:any, consent:any){
  const phnvalid = this.authService.validatePhone(mobile);

  if(!name || !mobile || !email || !password){
    $(".errormod").html("All fields are required");
    $(".errormod").show();
    return;
  }
  else if(!phnvalid){
    $(".errormod").html("Please check your phone number");
    $(".errormod").show();
    return;
  }
  else if(!consent){
    $(".errormod").html("Please check the consent box to proceed.");
    $(".errormod").show();
    return;
  }

  this.authService.checkOtp(mobile, otpnew).subscribe((isValid) => {

    // OTP not requested yet — send it and reveal the field instead of validating
    if(!this.otpShow){
      $(".errormod").hide();
      this.generateOtp(mobile);
      this.otpShow=true;
      $("#otp").show();
      return;
    }

    // If OTP was shown but is wrong
    if(!isValid){
      $(".errormod").html("Wrong OTP");
      $(".errormod").show();
      return;
    }

    $(".errormod").hide();
    this.authService.register(name, mobile, email, password).subscribe((Response) => {
      if (Response.status === "success") {
        this.authService.setSession(Response.customer_id, Response.customer_name, Response.token);
        this.ngOnInit();
        if(this.slctli.length>0){
          $(".driverprefer").show();
        }
      }
      else{
        $(".errormod").html(Response.message);
        $(".errormod").show();
      }
    });
  });
}
  public bookingsummary(){
    let bsummary = JSON.parse(localStorage.getItem("booking_step1") || '{}');
    this.ttype=bsummary.data[0].trip_type;
    this.btype=bsummary.data[0].booking_type;
    $('#from').val(bsummary.data[0].from);
    $('#to').val(bsummary.data[0].to);
    this.addresses=bsummary.data[0].stops;
    this.hasReturnTrip = bsummary.data[0].add_return_trip === true || bsummary.data[0].add_return_trip === '1';
    this.returnPickupDate = bsummary.data[0].return_trip_date || '';
    this.returnPickupTime = bsummary.data[0].return_trip_time || '';
    if (bsummary.data[0].pickup_date) {
      const storedPickupDate = new Date(bsummary.data[0].pickup_date);
      if (!isNaN(storedPickupDate.getTime())) {
        this.pickupDate = storedPickupDate;
      }
    }
    this.pickupTime = bsummary.data[0].pickup_time || '';
  }
  public vehiclechange(){
      if(this.vehicletype=="Mini van" || this.vehicletype=="passenger van"){
        // this.rate=2.05;
        this.calculate();
      }
      else{
        // this.rate=2.05;
        this.calculate();
      }
      
    $('.preloader').show();
      let bsummary = JSON.parse(localStorage.getItem("booking_step1") || '{}');
      const headers = { 'Content-type': 'application/json'};
      const body = {
        title: 'Booking',
        address:bsummary.data[0].from,
        vehicle:this.vehicletype,
        c_id:this.authService.getCustomerId(),
      };
      this.http.post(GlobalConstants.apiURL+'driverdeliver', body, { headers })
        .subscribe((Response: any) => {
          // console.log('Response');
          // console.log(Response);
          
    $('.preloader').hide();
        this.slctli = Response;
        this.drivers = this.slctli.list;
        console.log(Response);
          if (Response.length>0) {
            for(let z=0; z<Response.length; z++){
              if(Response[z].favourite=='1'){
                this.checkfavdrvr=true;
                break;
              }
              else{
                this.checkfavdrvr=false;
              }
            }
            $(".driverprefer").show();
          }
          else{
            $(".driverprefer").hide();

          }
  
  
        });
  }
  public ondatechange() {
    this.calculate();
  }
  public preBook(from: any, to: any, triptype: any,booktype:any) {
    this.addstops=0;
    if(from==""|| from==undefined || from==null || to==""|| to==undefined || to==null){
      $("#error5").show();
    }
    else{
      $("#error5").hide();
      
      let stopsdata = {
        data: [],
      };
      if(this.addresses.length >0){
        this.addstops=1;
      }
      if(this.addstops=="1"){
        
        for (let count = 1; this.addresses.length >= count; count = count + 1) {
          if((<HTMLInputElement>document.getElementById('stopname' + count)).value =="" || 
          (<HTMLInputElement>document.getElementById('stopname' + count)).value == undefined ||
          (<HTMLInputElement>document.getElementById('stopname' + count)).value == null){
            $("#error5").show();
            return; 
            
          }
          else{
            $("#error5").hide();
            stopsdata['data'].push({
              'stop-number': count,
              'stop_name': (<HTMLInputElement>document.getElementById('stopname' + count)).value,
              'stop_waiting': $("#stopwait"+count+" select").val(),
            });
          }
         
        }
      }
      
      const existing = JSON.parse(localStorage.getItem('booking_step1') || '{"data":[{}]}');
      let schedule_book = {
        data: [
          {
            from: from,
            to: to,
            havestops: this.addstops,
            stops: stopsdata.data,
            trip_type: triptype,
            booking_type:booktype,
            pickup_date: this.pickupDate || '',
            pickup_time: this.pickupTime || '',
            add_return_trip: existing.data[0].add_return_trip || false,
            return_trip_date: existing.data[0].return_trip_date || '',
            return_trip_time: existing.data[0].return_trip_time || '',
            return_stops: (stopsdata.data || []).slice().reverse(),
          },
        ],
      };
      localStorage.setItem('booking_step1', JSON.stringify(schedule_book));
      this.calculate();
      this.route.navigate(['/booking'])
  .then(() => {
    this.calculate();
    window.location.reload();
    this.calculate();
  });
    }
  }
  public onPassengerchange(passengers: any) {
    const p = parseInt(passengers) || 0;

    // Sedan/SUV: max 4
    if (p <= 4) { $('#suv').show(); } else {
      $('#suv').hide();
      if (this.vehicletype === 'suv' || this.vehicletype === 'sedan') { this.vehicletype = ''; }
    }
    // Truck: max 5
    if (p <= 5) { $('#truck').show(); } else {
      $('#truck').hide();
      if (this.vehicletype === 'truck') { this.vehicletype = ''; }
    }
    // Mini Van: max 7
    if (p <= 7) { $('#outstation').show(); } else {
      $('#outstation').hide();
      if ((this.vehicletype || '').toLowerCase() === 'mini van') { this.vehicletype = ''; }
    }
    // 15-Passenger Van: max 14
    if (p <= 14) { $('#passengervan').show(); } else {
      $('#passengervan').hide();
      if (this.vehicletype === 'passenger van') { this.vehicletype = ''; }
    }
  }

  public onroundtripWaitingchange(waiting:any){
    this.roundtripWaitings=waiting;
    this.calculate(); 
  }
 
  public editbSummary(){
    $('#bsummary').addClass('active');
    $('.active input').prop("disabled", false); 
    $('.active select').prop("disabled", false); 
    $('.active button').prop("disabled", false); 
    $('.active .d-none').removeClass("d-none");
    $('.readonly-wrapper').removeClass("readonly-wrapper");
    $('.booknow').show();
    $('.edit-btn').hide();
  }
   public checkchanged(){
     if($("#checkbx input").prop("checked")==true){
       $(".instantreg").hide();
       $(".instantlogin").show();
       $("#otp").hide();
     }
     else{
      $(".instantreg").show();
      $(".instantlogin").hide();
     }
  }

fetchCustomerDetails(): void {
  // Only show preloader and fetch if user is logged in
  if (this.authService.isLoggedIn()) {
    $('.preloader').show();

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      customer_id: this.authService.getCustomerId(),
    };

    this.http.post(GlobalConstants.apiURL + 'customerdetails', body, { headers })
      .subscribe({
        next: (response: any) => {
          this.wallet = response.customer.wallet || 0;
          $('.preloader').fadeOut();
        },
        error: (error) => {
          $('.preloader').fadeOut();
        }
      });
  } else {
    // User not logged in, ensure preloader is hidden
    this.wallet = 0;
  }
}
// wallet code 
validateWalletApply(): void {
      $('.preloader').show();
  
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      const body = {
        customer_id: this.authService.getCustomerId(),
        amount: this.walletUsageAmount,
      };
  
      this.http.post(GlobalConstants.apiURL + 'validatewallet', body, { headers })
        .subscribe({
          next: (response: any) => {
            console.log(response);
            if(response.valid==true){
            $('.preloader').fadeOut();
            
                   this.otpRequested = true;
                   this.validatedwalletUsageAmount= this.walletUsageAmount;
                   this.walletOtpVerified=false;
              Swal.fire({
                title: 'Success',
                text: "Wallet amount is valid. Proceeding to OTP verification.",
                icon: 'success',
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                  // this.submitWalletAmount();
                }
              });
            }
            else{
              
            $('.preloader').fadeOut();
              Swal.fire('Error', 'Insufficient wallet balance or invalid amount.', 'error');}
          },
          error: (error) => {
            $('.preloader').fadeOut();
          }
        });
    }
submitWalletAmount() {
  if (this.walletUsageAmount > 0 && this.walletUsageAmount <= this.wallet && (this.walletUsageAmount <= this.totalPrice + this.validatedwalletUsageAmount)) {
    this.validateWalletApply();
  } else {
    alert('Enter a valid amount within wallet balance and total price.');
  }
}

editWalletUsage() {
  this.otpRequested = false;
  this.walletOtp = '';
}

confirmWalletUsage() {
  if (this.walletOtp.length === 4) {
      $('.preloader').show();
  
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      const body = {
        customer_id: this.authService.getCustomerId(),
        otp: this.walletOtp,
      };
  
      this.http.post(GlobalConstants.apiURL + 'validatewalletotp', body, { headers })
        .subscribe({
          next: (response: any) => {
            console.log(response);
            if(response.valid==true){
              this.walletOtpVerified=true;
              this.calculate();
            $('.preloader').fadeOut();
              Swal.fire({
                title: 'Success',
                text: "OTP verification successful. Wallet amount applied.",
                icon: 'success',
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                }
              });
            }
            else{
              
            $('.preloader').fadeOut();
              Swal.fire('Error', 'Invalid otp.', 'error');
            }
          },
          error: (error) => {
            $('.preloader').fadeOut();
              Swal.fire('Error', 'Invalid otp.', 'error');
          }
        });
  } else {
    alert('Enter a valid 4-digit OTP.');
  }
}
// wallent code end 
  public waitingdays(nowdays:any){
    this.noOfDays = parseInt(nowdays) || 1;
    this.calculate();
  }
  public calculate() {

    let step1 = JSON.parse(localStorage.getItem("booking_step1") || '{}');
    let ttrip_type = step1.data[0].trip_type;

    let stopsall = step1.data[0].stops;
    var stops = [];
    for (let i = 0; i < stopsall.length; i++) {
      stops.push(stopsall[i].stop_name.toString());
    }
    stops.push(step1.data[0].to);
    var fromstops = [];
    fromstops.push(step1.data[0].from);
    for (let i = 0; i < stopsall.length; i++) {
      fromstops.push(stopsall[i].stop_name.toString());
    }

    const geocoder = new google.maps.Geocoder();

    const service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: fromstops,
        destinations: stops,
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
        avoidHighways: false,
        avoidTolls: false,
      },
      (response, status) => {
        if (status !== "OK") {
          console.log("Error was: " + status);
        }
        else {
          let total = 0;
          for (let i = 0; i < response.rows[0].elements.length; i++) {
            if (response.rows[i].elements[i].status == "ZERO_RESULTS" || response.rows[i].elements[i].status == "NOT_FOUND") {
              Swal.fire('Error', 'no routes found', 'error');
              this.route.navigate(['/']);
            }
            else {
              total = total + response.rows[i].elements[i].distance.value;
            }

          }
          // One-way distance only: /apis/calculatefare doubles it internally for roundtrip.
          let oneWayMiles = total * 0.000621371;
          oneWayMiles = (Math.round(oneWayMiles * 100)) / 100.0;
          this.totalMiles = ttrip_type === "roundtrip"
            ? parseFloat((oneWayMiles * 2).toFixed(2))
            : oneWayMiles;

          this.fetchFare(ttrip_type, oneWayMiles, stopsall);
        }
      }
    );
  }

  private clearFare() {
    this.rate = 0;
    this.charge = 0;
    this.chargeRound = 0;
    this.trailerCost = 0;
    this.waitingcharge = 0;
    this.waitingchargeRound = 0;
    this.waitingdayscharge = 0;
    this.roundTripwaitingcharge = 0;
    this.promocodeAmount = 0;
    this.SpecialDayMessage = '';
    this.totalPrice = 0;
  }

  private fetchFare(ttrip_type: string, oneWayMiles: number, stopsall: any[]) {
    if (!this.vehicletype) {
      this.clearFare();
      this.fareMessage = 'Please choose a vehicle type to see pricing.';
      return;
    }

    const stopWaitingMinutes = stopsall.map((s: any) => parseInt(s.stop_waiting) || 0);
    this.totalWaititng = stopWaitingMinutes.reduce((a: number, b: number) => a + b, 0);

    let today = new Date();
    let pdate = $("#pdate").val();
    if (pdate != "") {
      today = new Date(pdate);
    }
    const tripDate = this.datepipe.transform(today, 'yyyy-MM-dd');

    const body: any = {
      vehicle_type: this.vehicletype,
      trip_type: ttrip_type,
      distance: oneWayMiles,
      stop_waiting_minutes: stopWaitingMinutes,
      trailer_towing: this.trailerTowing,
      tip: this.tipAmount || 0,
      trip_date: tripDate,
    };
    if (ttrip_type === "outstation") {
      body.no_of_days = this.noOfDays || 1;
    }
    if (ttrip_type === "roundtrip") {
      body.roundtrip_waiting_minutes = this.roundtripWaitings || 0;
    }
    if (this.promocodeApplied) {
      body.promocode = this.promocodeApplied;
    }

    const headers = { 'Content-type': 'application/json' };
    this.http.post(GlobalConstants.apiURL + 'calculatefare', body, { headers })
      .subscribe({
        next: (Response: any) => {
        if (Response && Response.status === "success") {
          this.fareMessage = '';
          const data = Response.data;

          this.rate = data.rate_per_mile;
          this.charge = data.distance_charge;
          this.chargeRound = (Math.round(data.distance_charge * 100)) / 100.0;
          this.trailerCost = data.trailer_towing_charge;
          this.waitingcharge = data.waiting_charge;
          this.waitingchargeRound = (Math.round(data.waiting_charge * 100)) / 100.0;
          this.waitingdayscharge = data.day_waiting_charge;
          this.roundTripwaitingcharge = data.roundtrip_waiting_charge;
          this.promocodeAmount = data.promo_discount;

          this.SpecialDayMessage = data.special_date_reason
            ? `Today is ${data.special_date_reason}! A special amount of $${data.special_date_surcharge} is applied.`
            : '';

          if (this.promocodeApplied && data.promocode_valid === false) {
            Swal.fire('Sorry', data.promocode_message, 'error');
          }

          const oneTripPrice = data.trip_amount;
          let price = this.hasReturnTrip ? oneTripPrice * 2 : oneTripPrice;
          if (this.walletOtpVerified == true) {
            price = price - this.validatedwalletUsageAmount;
          }
          this.totalPrice = parseFloat(price.toFixed(2));

          const booking = JSON.parse(localStorage.getItem('booking_step1') || '{}');
          if (booking.data && booking.data[0]) {
            booking.data[0].outbound_total_price = parseFloat(oneTripPrice.toFixed(2));
            booking.data[0].return_total_price = this.hasReturnTrip ? parseFloat(oneTripPrice.toFixed(2)) : 0;
            localStorage.setItem('booking_step1', JSON.stringify(booking));
          }

          localStorage.setItem("totaldistance", this.totalMiles);
          const roundtripWaitings_ = this.roundtripWaitings ?? 0; // use 0 if undefined or null
          localStorage.setItem("roundtripWaitings", roundtripWaitings_.toString());
          localStorage.setItem("roundTripwaitingcharge", this.roundTripwaitingcharge);
          localStorage.setItem("totalprice", this.totalPrice);
          localStorage.setItem("waitingchargeround", this.waitingchargeRound);
          localStorage.setItem("chargeround", this.chargeRound);
          localStorage.setItem("tip", (this.tipAmount ?? 0).toString());
        } else {
          this.clearFare();
          this.fareMessage = (Response && Response.message) || 'Unable to calculate fare. Please check your trip details.';
        }
        },
        error: () => {
          this.clearFare();
          this.fareMessage = 'Unable to calculate fare. Please check your trip details.';
        }
      });
  }

 
  
  public bookingstep2(date:any,time:any,passengers:any,returndate:any,returntime:any,nowdays:any,prefferddriver:any,state:any,comment:any){
    if(time==undefined){
      time=0;
    }
    if(this.datetime === true && (date === "" || date === null || date === undefined))
    {
      
      $("#step2error").show();
      $("#step2error p").html("Start date and time are required.");
    } 
    else if(this.isoutstation==true && returndate=="" || this.isoutstation==true && returndate==null || this.isoutstation==true && returndate==undefined)
    { 
      $("#step2error").show();
      $("#step2error p").html("Return date is required.");
    }
    else if(this.isoutstation==true && returntime=="" || this.isoutstation==true && returntime==null || this.isoutstation==true && returntime==undefined)
      { 
        $("#step2error").show();
        $("#step2error p").html("Return time is required.");
      }
    else if(passengers=="" || passengers==null || passengers==undefined){
      $("#step2error").show();
      $("#step2error p").html("Please enter number of passengers.");
    }
    else if(this.vehicletype=="" || this.vehicletype==null || this.vehicletype==undefined){
      $("#step2error").show();
      $("#step2error p").html("Please choose vehicle type.");
    }
    // else if(this.checked==false){
    //   $("#step2error").show();
    //   $("#step2error p").html("Please agree terms & condtions.");
    // }
    else if(!this.authService.isLoggedIn()){

      

      
      this.roundtripWaitings = this.roundtripWaitings || 0;
      
      localStorage.setItem("totalprice",this.totalPrice); 
      let temp = JSON.parse(localStorage.getItem("booking_step1") || '{}');
      temp.data[0]['start_date']= date;
      temp.data[0]['start_time']= time;
      temp.data[0]['passengers']= passengers;
      temp.data[0]['return_date']= returndate;
      temp.data[0]['return_time']= returntime;
      temp.data[0]['total_price']= this.totalPrice;
      temp.data[0]['total_distance']= this.totalMiles;
      temp.data[0]['vehicle_type']=this.vehicletype;
      temp.data[0]['nowdays']=nowdays;
      temp.data[0]['comment']=comment;
      temp.data[0]['promocode']=this.promocodeApplied;
      temp.data[0]['promocodeval']=this.promocodeAmount;
      temp.data[0]['promocodeid']=this.promocodeID;
      temp.data[0]['from_wallet']=this.validatedwalletUsageAmount;
      
      temp.data[0]['roundtripWaitings']=this.roundtripWaitings.toString();
      temp.data[0]['roundTripwaitingcharge']=this.roundTripwaitingcharge;
      temp.data[0]['trailer_towing'] = this.trailerTowing ? 1 : 0;

      temp.data[0]['customer_id']=this.authService.getCustomerId();
      localStorage.setItem('tempdata', JSON.stringify(temp));
      $('.preloader').hide();
        let element: HTMLElement = document.getElementById(
          'customerlogin'
        ) as HTMLElement;
        element.click();
      
    }
    else{
      $("#step2error").hide();
     if (this.isButtonClicked) return;
    this.isButtonClicked = true;
    $('.preloader').show();
      let bookstep2 = JSON.parse(localStorage.getItem("booking_step1") || '{}');
      // localStorage.removeItem("booking_step1");

      this.roundtripWaitings = this.roundtripWaitings || 0;
      
      localStorage.setItem("totalprice",this.totalPrice);
      bookstep2.data[0]['start_date']= date;
      bookstep2.data[0]['start_time']= time;
      bookstep2.data[0]['passengers']= passengers;
      bookstep2.data[0]['return_date']= returndate;
      bookstep2.data[0]['return_time']= returntime;
      bookstep2.data[0]['total_price']= this.totalPrice;
      bookstep2.data[0]['total_distance']= this.totalMiles;
      bookstep2.data[0]['vehicle_type']=this.vehicletype;
      bookstep2.data[0]['nowdays']=nowdays;
      bookstep2.data[0]['comment']=comment;

      bookstep2.data[0]['roundtripWaitings']=this.roundtripWaitings.toString();
      bookstep2.data[0]['roundTripwaitingcharge']=this.roundTripwaitingcharge;
      
      bookstep2.data[0]['promocode']=this.promocodeApplied;
      bookstep2.data[0]['promocodeval']=this.promocodeAmount;
      bookstep2.data[0]['promocodeid']=this.promocodeID;
      bookstep2.data[0]['from_wallet']=this.validatedwalletUsageAmount;
      bookstep2.data[0]['driver']=prefferddriver;
      bookstep2.data[0]['d_favourite']=this.checked2;
      bookstep2.data[0]['customer_id']=this.authService.getCustomerId();
      bookstep2.data[0]['waiting_charge_minute']=this.waitingforMint;
      bookstep2.data[0]['total_waiting_time']=this.totalWaititng;
      bookstep2.data[0]['total_waiting_charge']=this.waitingcharge;
      bookstep2.data[0]['total_waitingdayscharge']=this.waitingdayscharge;
      bookstep2.data[0]['total_charge_distance']=this.charge;
      bookstep2.data[0]['rate_per_mile']=this.rate;
      bookstep2.data[0]['tip'] = (this.tipAmount ?? 0).toString();
      bookstep2.data[0]['trailer_towing'] = this.trailerTowing ? 1 : 0;

      localStorage.setItem('booking', JSON.stringify(bookstep2));
      
      // this.route.navigate(['/booking']);
      if(state=="later"){
        const headers = { 'Content-type': 'application/json'};
        const body = {
          title: 'Booking',
          bookingdata: bookstep2,
          favouritetrip: localStorage.getItem("favourite") || '',
          tripname: localStorage.getItem("tripname") || '',
        };
        this.http.post(GlobalConstants.apiURL+'booking', body, { headers })
          .subscribe((Response: any) => {
            if (Response) {
              console.log(Response);
              if(Response.status=="success"){
                $('.preloader').hide();
             
              Swal.fire({
                  title: 'Success',
                  text: "You will receive your ride confirmation and driver details in the registered phone number.",
                  icon: 'success',
                  confirmButtonText: 'OK'
                }).then((result) => {
                  if (result.isConfirmed) {
                    // this.route.navigate(['/my-bookings'])
                    // .then(() => {
                    //   window.location.reload();
                    // });
                    this.route.navigate(['/my-bookings']).then(() => {
                      // Navigation successful
                    }).catch(error => {
                      console.error('Navigation error:', error);
                      this.route.navigate(['/my-bookings'])
                    });
                  }
                })
              }
            }
    
    
          });
      }
      else{
        $('.preloader').hide();
        this.route.navigate(['/payment']).then(() => {
          // Navigation successful
        }).catch(error => {
          console.error('Navigation error:', error);
          this.route.navigate(['/payment'])
        });
      }
     
    }
}
}
